import * as z from 'zod';

export const brandQueryParamsSchema = z.object({
  edit: z.boolean().optional(),
});

export type BrandQueryParams = z.infer<typeof brandQueryParamsSchema>;
